import { render } from "./LG.vue?vue&type=template&id=79016510&scoped=true"
import script from "./LG.vue?vue&type=script&lang=js"
export * from "./LG.vue?vue&type=script&lang=js"

import "./LG.vue?vue&type=style&index=0&id=79016510&lang=scss&scoped=true"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79016510"]])

export default __exports__